import BaseViewController from "./base-view-controller";

class ListViewController extends BaseViewController {
  formState = {};

  preprocessScreenData() {
    if (this.screen?.data?.list_data) {
      const fields = this.screen.data.list_data.map(pharmacy => {
        return {
          childrenData: {
            componentName: "MailOrderPharmacyAddress",
            title: pharmacy.cell_data.title,
            subtitle: pharmacy.cell_data.subtitle
          },
          key: "selectedData",
          type: "listItemWrapper",
          title: "",
          selectedData: pharmacy,
          childrenType: "pharmacy-address"
        };
      });

      this.screen = {
        ...this.screen,
        fields
      };
    }
  }

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action) {
    console.log(text);
    if (name === "selectedData") {
      const mailOrderPharmacy =
        text.url_request_data?.erx_vendor_id &&
        text.url_request_data?.erx_vendor_code
          ? {
              erx_vendor_id: text.url_request_data.erx_vendor_id,
              erx_vendor_code: text.url_request_data.erx_vendor_code
            }
          : {};

      this.formState = {
        ...this.formState,
        [name]: text,
        pharmacy_view: text.url_request_data.pharmacy_view,
        ...mailOrderPharmacy
      };
    }
    super.handleButtonClick(name, text, action);
  }
}

export default ListViewController;
